import styled, { createGlobalStyle } from "styled-components";

export const LoadingWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    justify-content: center;
    align-content: center;
`;

export const Main = styled.div`
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    z-index: 3;
`;

export const GlobalStyle = createGlobalStyle`
  body {

  }
`;
